import React from 'react'
import { Box, IconButton } from '@mui/material'
import MailIcon from '@mui/icons-material/Mail'
import EditIcon from '@mui/icons-material/Edit'

import { useInstallerCalls, useInstallerDialogs } from '../../hooks'
import { useLoaderBasic } from '../../../loader/hooks'

export const TableActions = ({ backgroundColor, ...props }) => {
  const { resendValidation, updateInstallerInfo, getInstallers } = useInstallerCalls()
  const { warnValidationMailSuccess, editInstallerDialog } = useInstallerDialogs()
  const {
    state: { config },
    loadData,
  } = useLoaderBasic({ identifier: 'installers', call: getInstallers })

  const rowData = props.row?.original || props.rowData

  if (!rowData) {
    return null
  }

  const handleEdit = () => {
    editInstallerDialog(rowData, (id, payload) =>
      updateInstallerInfo(id, payload).then(() => loadData(config))
    )
  }

  const handleForward = () => {
    resendValidation(rowData['email']).then(warnValidationMailSuccess)
  }

  const showEditButton = !rowData?.['confirmed']
  const showForwardButton = rowData?.['oauth2_id'] && !rowData?.['confirmed']

  const actionButtonStyles = {
    border: '1px solid #333',
    borderRadius: '50%',
    height: '1.9em',
    width: '1.9em',
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
    },
  }

  const columnStyles = {
    flex: '1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        backgroundColor: backgroundColor,
        boxShadow: '4px 0 4px -4px rgba(97, 97, 97, 0.5) inset',
      }}
    >
      <Box sx={columnStyles}>
        {showEditButton && (
          <IconButton size="small" onClick={handleEdit} sx={actionButtonStyles}>
            <EditIcon />
          </IconButton>
        )}
      </Box>

      <Box sx={columnStyles}>
        {showForwardButton && (
          <IconButton size="small" onClick={handleForward} sx={actionButtonStyles}>
            <MailIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  )
}
